import type { FC, PropsWithChildren } from 'react';
import React, { useContext } from 'react';

const ThreadIsRootContext = React.createContext(false);

export const ThreadIsRootProvider: FC<PropsWithChildren<{ condition: boolean | undefined }>> = ({
  children,
  condition,
}) => {
  return (
    <ThreadIsRootContext.Provider value={condition ?? false}>
      {children}
    </ThreadIsRootContext.Provider>
  );
};

export const useThreadIsRoot = () => {
  return useContext(ThreadIsRootContext);
};
